import React, { useState } from "react";

//utils
import { onlynumber } from "../../utils/Helper/JSHelper";

function RegisterMobile(props) {
  //props
  const { onRegisterMobile, registerMobile } = props;

  //search variable
  const [register_mobile, set_register_mobile] = useState(registerMobile);

  //validate data
  function handle_register_mobile(e) {
    if (onlynumber(e, 10)) {
      set_register_mobile((register_mobile) => e.target.value);
    }
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col s10">
          <div className="div_input_text_search">
            <input
              type="text"
              className="form_input_text"
              id="register_mobile"
              name="register_mobile"
              placeholder="Register Mobile No"
              value={register_mobile}
              onChange={(e) => handle_register_mobile(e)}
            />
          </div>
        </div>
        <div className="col s2">
          <i
            className="fa fa-plus fa-2x btn btn-floating green"
            onClick={() => onRegisterMobile(register_mobile)}
            style={{ zIndex: "0" }}
          ></i>
        </div>
      </div>
    </React.Fragment>
  );
}

export default RegisterMobile;
